var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(" 已匯入資料，視窗將自動關閉，或請 "),_c('b-button',{on:{"click":_vm.close}},[_vm._v("點我關閉")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }